import { environnement } from "configs/environnement";
import api from "./api";
import { IEventResponse, ISaveEvent, IUpdateEvent } from "models/church.types";

const BASE_URL = `${environnement.baseURL}/events`;

export const EventService = {
  /**
   * Récupérer la liste complète des événements (paginée)
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IEventResponse[]>(`${BASE_URL}/_search`, {
      params: {
        page: page,
        size: size,
        sort: "eventDate,desc", // Tri par date d'événement par défaut
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * Créer un nouvel événement
   */
  create: async (event: ISaveEvent): Promise<IEventResponse> => {
    const response = await api.post<IEventResponse>(`${BASE_URL}`, event);
    return response.data;
  },

  /**
   * Mettre à jour un événement existant
   */
  update: async (event: IUpdateEvent): Promise<IEventResponse> => {
    const response = await api.put<IEventResponse>(`${BASE_URL}`, event);
    return response.data;
  },

  /**
   * Récupérer un événement par son ID
   */
  getById: async (id: number): Promise<IEventResponse> => {
    const response = await api.get<IEventResponse>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Supprimer un événement
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Rechercher des événements par mot-clé (Elasticsearch)
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IEventResponse[]>(`${BASE_URL}/_search`, {
      params: {
        query: query,
        page: page,
        size: size,
        sort: "eventDate,desc",
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
